(function () {
  'use strict';
  var tpl = document.querySelector('template[data-hg-promo-tile]');
  if (!tpl || window.__hgPromoTile) return;
  window.__hgPromoTile = true;

  var raf = 0;

  function findList() {
    return document.querySelector('#fish-grid-container ul.product-grid') ||
      document.querySelector('ul#product-grid');
  }

  /* Позиции плиток на странице — 3, 7 и 20 (ТЗ Grant, 23.10.2026, как у SportRx на самых загруженных
     страницах): не больше трёх плиток в первых 24 товарах; сколько плиток и какие — решает
     sections/collection-promo-tile.liquid. Позиция считается вместе с плитками выше, поэтому
     якорь (сколько карточек перед плиткой) = позиция − 1 − k. Колонка выходит своя у каждой
     плитки сама. Якорь — сама карточка, порядок товаров не трогаем. Плитка, для которой не
     хватает карточек, не показывается (первая — всегда, в конце списка). */
  var POSITIONS = [3, 7, 20];

  function place() {
    raf = 0;
    var list = findList();
    if (!list) return;
    var cards = Array.prototype.filter.call(list.children, function (el) {
      return !el.hasAttribute('data-hg-promo-tile-item');
    });
    Array.prototype.forEach.call(tpl.content.children, function (src, k) {
      var idx = src.getAttribute('data-hg-promo-idx');
      var tile = list.querySelector(':scope > [data-hg-promo-idx="' + idx + '"]');
      if (k >= POSITIONS.length) { if (tile) tile.remove(); return; }
      var anchor = k === 0 ? Math.min(POSITIONS[0] - 1, cards.length) : POSITIONS[k] - 1 - k;
      if (!cards.length || (k > 0 && anchor >= cards.length)) { if (tile) tile.remove(); return; }
      var ref = cards[anchor] || null;
      if (tile && tile.nextElementSibling === ref) return;
      if (!tile) tile = src.cloneNode(true);
      list.insertBefore(tile, ref);
    });
  }

  function schedule() { if (!raf) raf = setTimeout(place, 30); }

  /* Grid mutations: place synchronously. MutationObserver callbacks run as a
     microtask before the browser paints, so the tile lands in the same frame
     as the freshly rendered cards. The old 30 ms timer let the cards paint
     first and then shoved cards 3+ one slot over — a visible jump.
     Our own insertBefore re-triggers the observer; place() then sees the
     tile already at the wanted index and returns. */
  var obs = new MutationObserver(function () {
    if (raf) { clearTimeout(raf); raf = 0; }
    place();
  });
  var watched = null;
  // fish создаёт #fish-grid-container уже после старта — пока его нет, следим за body
  function watch() {
    var root = document.getElementById('fish-grid-container') || document.getElementById('product-grid');
    if (root === watched) return;
    obs.disconnect();
    watched = root;
    if (root) obs.observe(root, { childList: true, subtree: true });
    else obs.observe(document.body, { childList: true, subtree: true });
  }
  var rootObs = new MutationObserver(function () {
    if (!watched || !document.body.contains(watched)) watch();
  });
  function start() {
    watch();
    rootObs.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('fish:rendered', schedule);
    /* Поворот экрана / смена ширины окна меняет число колонок. */
    var lastW = window.innerWidth;
    window.addEventListener('resize', function () {
      if (window.innerWidth === lastW) return;
      lastW = window.innerWidth;
      schedule();
    }, { passive: true });
    schedule();
  }

  /* Клик в GA4 — как клик по меню (layout/theme.liquid, блок 6): select_content, у которого
     в GA4 маппятся только content_type и method. Без UTM в ссылке — иначе GA4 начал бы
     новую сессию с источником «promo». method = устройство|коллекция|слот|путь ссылки. */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-hg-promo-tile-item] a[href]');
    if (!a) return;
    var li = a.closest('[data-hg-promo-tile-item]');
    var slot = li && li.parentElement ? Array.prototype.indexOf.call(li.parentElement.children, li) + 1 : 0;
    var path = '';
    try { path = new URL(a.href, location.href).pathname; } catch (err) {}
    var dev = window.matchMedia('(max-width: 749px)').matches ? 'mobile' : 'desktop';
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'select_content',
      content_type: 'promo_tile',
      method: dev + '|' + (li && li.getAttribute('data-collection') || '') + '|' + slot + '|' + path
    });
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
